import { Injectable } from '@angular/core';
import { EntityCollectionServiceBase, EntityCollectionServiceElementsFactory } from '@ngrx/data';
import { Observable } from 'rxjs';
import { SchoolDistrict } from 'src/app/model/schoolDistrict.model';

@Injectable({
    providedIn: 'root'
})
export class DistrictEntityService extends EntityCollectionServiceBase<SchoolDistrict> {
    constructor(serviceElementsFactory: EntityCollectionServiceElementsFactory) {
        super('District', serviceElementsFactory);
    }
}
